import { combineReducers } from 'redux';
import { login, checkUserExist, userExists, userNotExists, register, confirmRegister } from '../sagas/auth/actions';
import { logoutButtonClick, resetPhoneClick } from '../components/Auth/actions';

const isAuthenticated = (state = false, action) => {
  if (action.type === login.done.type) {
    return true;
  }

  if (action.type === logoutButtonClick.type) {
    localStorage.clear();
    return false;
  }

  return state;
};

const registerError = (state = false, action) => {
  if (action.type === register.failed.type) {
    return true;
  }

  return state;
};

const registerSucceeded = (state = false, action) => {
  if (action.type === register.done.type) {
    return true;
  }

  return state;
};

const registerConfirmed = (state = false, action) => {
  if (action.type === confirmRegister.done.type) {
    return true;
  }

  return state;
};

const error = (state = '', action) => {
  if (action.type === login.failed.type) {
    return 'неправильный пароль';
  }

  return state;
};

const profile = (state = {}, action) => {
  if (action.type === login.done.type) {
    return action.payload.result.profile;
  }

  if (action.type === logoutButtonClick.type) {
    return {};
  }

  return state;
};

const existenceChecked = (state = false, action) => {
  if (action.type === checkUserExist.done.type) {
    return true;
  }

  if (action.type === logoutButtonClick.type) {
    return false;
  }

  if (action.type === resetPhoneClick.type) {
    return false;
  }

  return state;
};

const userIsRegistered = (state = false, action) => {
  if (action.type === userExists.type) {
    return true;
  }

  if (action.type === userNotExists.type) {
    return false;
  }

  if (action.type === resetPhoneClick.type) {
    return false;
  }

  if (action.type === logoutButtonClick.type) {
    return false;
  }

  if (action.type === login.done.type) {
    return true;
  }

  if (action.type === confirmRegister.type) {
    return true;
  }

  return state;
};

const phone = (state = '', action) => {
  if (action.type === checkUserExist.started.type) {
    return action.payload.phone;
  }

  if (action.type === resetPhoneClick.type) {
    return '';
  }

  if (action.type === logoutButtonClick.type) {
    return '';
  }

  return state;
};

export default combineReducers({
  isAuthenticated,
  error,
  registerError,
  registerSucceeded,
  registerConfirmed,
  profile,
  existenceChecked,
  userIsRegistered,
  phone,
});



// WEBPACK FOOTER //
// ./src/reducers/auth.js